import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  OPEN_PANEL_MAIN_CONTENT_RIGHT_CONVERTER_TOKEN, OpenPanelMainContentRightConverter
} from './open-panel-main-content-right.component.converter'
import {
  OPEN_PANEL_MAIN_CONTENT_RIGHT_ROW_CONVERTER_TOKEN, OpenPanelMainContentRightRowConverter
} from './open-panel-main-content-right-row/open-panel-main-content-right-row.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        openPanelMainContentRightFeature: {
          module: () => import('./open-panel-main-content-right.module').then((m) => m.OpenPanelMainContentRightModule),
          cmsComponents: ['openpanelmaincontentright'],
          dependencies: [
            () => import('../open-panel-subcomponent-wrapper/open-panel-subcomponent-wrapper-feature.module').then(m => m.OpenPanelSubcomponentWrapperFeatureModule)
          ]
        },
      }
    }),
    {
      provide: OPEN_PANEL_MAIN_CONTENT_RIGHT_CONVERTER_TOKEN,
      useExisting: OpenPanelMainContentRightConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        openpanelmaincontentright: OPEN_PANEL_MAIN_CONTENT_RIGHT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: OPEN_PANEL_MAIN_CONTENT_RIGHT_ROW_CONVERTER_TOKEN,
      useClass: OpenPanelMainContentRightRowConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        openpanelmaincontentrightrow: OPEN_PANEL_MAIN_CONTENT_RIGHT_ROW_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class OpenPanelMainContentRightFeatureModule {}
